/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthSubmissionStatusInfo
 */
export interface PalReauthSubmissionStatusInfo {
    /**
     * 
     */
    status?: string | null;
    /**
     * 
     */
    level?: string | null;
    /**
     * 
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the PalReauthSubmissionStatusInfo interface.
 */
export function instanceOfPalReauthSubmissionStatusInfo(value: object): value is PalReauthSubmissionStatusInfo {
    return true;
}

export function PalReauthSubmissionStatusInfoFromJSON(json: any): PalReauthSubmissionStatusInfo {
    return PalReauthSubmissionStatusInfoFromJSONTyped(json, false);
}

export function PalReauthSubmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionStatusInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'level': json['level'] === undefined ? undefined : json['level'] === null ? null : json['level'],
        'comment': json['comment'] === undefined ? undefined : json['comment'] === null ? null : json['comment'],
    };
}

export function PalReauthSubmissionStatusInfoToJSON(json: any): PalReauthSubmissionStatusInfo {
    return PalReauthSubmissionStatusInfoToJSONTyped(json, false);
}

export function PalReauthSubmissionStatusInfoToJSONTyped(value?: PalReauthSubmissionStatusInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'level': value['level'],
        'comment': value['comment'],
    };
}

